export default "__VITE_ASSET__BRM6VTe5__"